import { useContext } from 'react';

import { FieldSelect } from '@/components/looker/field-select';
import { IPCSRepository } from '@/pcs/domain/repositories/pcs.repository';

import { PCSOverviewContext } from '../../pages/pcs-overview';
import { useListPCSs } from '../../queries/use-list-pcs';

export type PCSFilterProps = {
  filters: IPCSRepository.Filters;
  onChange: (value?: string) => void;
};

export function PCSFilter({ filters, onChange }: PCSFilterProps) {
  const asset = useContext(PCSOverviewContext);

  // NOTE: assertion for asset here, as we assume the asset is always available
  const listPCSs = useListPCSs({
    filters,
    assetFullFrontendId: asset!.fullFrontendId,
  });

  return (
    <FieldSelect
      key={filters.pcsId} // Force re-render when pcsId changes
      label="PCS"
      placeholder={`Filter by PCS`}
      value={filters.pcsId}
      options={listPCSs.data?.pcss.map(({ label }) => ({ value: label })) ?? []}
      onChange={(label) => onChange(label ?? undefined)}
      isClearable={true}
    />
  );
}
